



















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { GetSpaceRights, GetToolRights } from '../../../api/common/index';

@Component({
  name: 'EnterpriseRight',
})
export default class EnterpriseRight extends Vue {
  spaceRights = {} as any;
  toolRights = [] as any;
  async mounted() {
    await this.getDetail();
  }
  async getDetail() {
    await GetSpaceRights().then(res => {
      this.spaceRights = res;
    });
    await GetToolRights().then(res => {
      this.toolRights = [res[2], res[0], res[1]];
    });
  }

  toRightCenter() {
    this.$router.push('/rightCenter');
  }
}
